import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaCogs, FaImages, FaUsers, FaComments, FaHandshake,
  FaArrowRight, FaBuilding, FaGlobe, FaAward
} from 'react-icons/fa';
import { useAdmin } from '../context/AdminContext';
import './Dashboard.css';

const Dashboard = () => {
  const { data, user, loading } = useAdmin();

  const servicesCount = data?.services?.length ?? 0;
  const galleryCount = data?.gallery?.length ?? 0;
  const teamCount = data?.team?.length ?? 0;
  const testimonialsCount = data?.testimonials?.length ?? 0;

  const contentStats = [
    { icon: <FaCogs />, label: 'Group Businesses', count: servicesCount, color: '#c9a227', link: '/admin/services' },
    { icon: <FaImages />, label: 'Gallery Assets', count: galleryCount, color: '#10b981', link: '/admin/gallery' },
    { icon: <FaUsers />, label: 'Board Directors', count: teamCount, color: '#3b82f6', link: '/admin/team' },
    { icon: <FaComments />, label: 'Group Testimonials', count: testimonialsCount, color: '#8b5cf6', link: '/admin/testimonials' },
  ];

  const displayName =
    user?.full_name ||
    user?.username ||
    user?.email ||
    data?.header?.user_name ||
    'Executive Admin';

  if (loading) {
    return (
      <div className="sg-loader-container">
        <div className="sg-loader-ring"></div>
        <p>Loading Executive Dashboard...</p>
      </div>
    );
  }

  return (
    <div className="dashboard">
      {/* Welcome Board */}
      <div className="dashboard-welcome">
        <div className="welcome-text-block">
          <h2>Welcome back, {displayName}</h2>
          <p>Central holding console for Sarwa Group Operations.</p>
        </div>
        <div className="welcome-date">
          <span>
            {new Date().toLocaleDateString('en-US', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </span>
        </div>
      </div>

      {/* Corporate Overview Strip */}
      <div className="key-metrics">
        <div className="metric-card">
          <div className="metric-icon"><FaBuilding /></div>
          <div className="metric-content">
            <span className="metric-label">Parent Group</span>
            <h3>Sarwa Group</h3>
            <span className="metric-change">Active Subsidiaries</span>
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-icon"><FaGlobe /></div>
          <div className="metric-content">
            <span className="metric-label">Active Verticals</span>
            <h3>{servicesCount} Divisions</h3>
            <span className="metric-change">Operational Industries</span>
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-icon"><FaAward /></div>
          <div className="metric-content">
            <span className="metric-label">Audit Standards</span>
            <h3>Grade A</h3>
            <span className="metric-change">Verified Compliance</span>
          </div>
        </div>
      </div>

      {/* Content Overview */}
      <div className="dashboard-section">
        <div className="section-header">
          <h3>Subsidiary Operations Hub</h3>
          <span className="section-desc">Manage core portfolio data and communications across the enterprise</span>
        </div>
        <div className="stats-grid">
          {contentStats.map((stat, i) => (
            <Link to={stat.link} key={i} className="stat-card">
              <div className="stat-icon" style={{ background: `${stat.color}15`, color: stat.color }}>
                {stat.icon}
              </div>
              <div className="stat-info">
                <span className="stat-label">{stat.label}</span>
                <h4>{stat.count}</h4>
              </div>
              <div className="stat-arrow"><FaArrowRight /></div>
            </Link>
          ))}
        </div>
      </div>

      {/* Quick Action Matrix */}
      <div className="dashboard-section" style={{ marginTop: "40px" }}>
        <div className="section-header">
          <h3>Centralized HQ Actions</h3>
        </div>
        <div className="quick-actions">
          <Link to="/admin/services" className="action-card">
            <FaCogs />
            <span>Add Subsidiary</span>
          </Link>
          <Link to="/admin/gallery" className="action-card">
            <FaImages />
            <span>Upload Assets</span>
          </Link>
          <Link to="/admin/team" className="action-card">
            <FaUsers />
            <span>Appoint Board Member</span>
          </Link>
          <Link to="/admin/partners" className="action-card">
            <FaHandshake />
            <span>Register Partner</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;